export const CONTRACT_SYSTEM_PARAMS = [
    { title: 'fullname', value: 'fullname', label: 'Họ tên' },
    { title: 'code', value: 'code', label: 'Mã nhân viên' },
    { title: 'gioitinh', value: 'sex', label: 'Giới tính' },
    { title: 'email', value: 'email', label: 'Email' },
    { title: 'mobile', value: 'mobile', label: 'Số điện thoại' },
    { title: 'socccd', value: 'cccd', label: 'Số CCCD/CMND/HC' },
    { title: 'birthday', value: 'birthday', label: 'Ngày sinh' },
    { title: 'ngaycapcccd', value: 'cccd_date', label: 'Ngày cấp CCCD/CMND/HC' },
    { title: 'noicapcccd', value: 'cccd_address', label: 'Nơi cấp CCCD/CMND/HC' },
    { title: 'dcthuongtru', value: 'address_tc', label: 'Địa chỉ thường trú' },
    { title: 'address', value: 'address', label: 'Địa chỉ hiện tại' },
    { title: 'bank_name', value: 'bank_name', label: 'Tên ngân hàng' },
    { title: 'stknganhang', value: 'bank_id', label: 'STK ngân hàng' },
    { title: 'chinhanhnganhang', value: 'bank_address', label: 'Chi nhánh ngân hàng' },
    { title: 'bhxh', value: 'bhxh_id', label: 'Mã bảo hiểm xã hội' },
    { title: 'mst', value: 'mst_id', label: 'Mã số thuế' },
    { title: 'ngaygianhap', value: 'datejoining', label: 'Ngày gia nhập' },
    { title: 'ngaynghiviec', value: 'ngaynghiviec', label: 'Ngày nghỉ việc' },
    { title: 'ngaybdhdtn', value: 'datestart_tapnghe', label: 'Ngày bắt đầu HĐ tập nghề' },
    { title: 'ngaykthdtn', value: 'dateend_tapnghe', label: 'Ngày kết thúc HĐ tập nghề' },
    { title: 'ngaybdhdkv', value: 'datestart_khoanviec', label: 'Ngày bắt đầu HĐ khoán việc' },
    { title: 'ngaykthdkv', value: 'dateend_khoanviec', label: 'Ngày kết thúc HĐ khoán việc' },
    { title: 'ngaybdhdtv', value: 'datehdtv_start', label: 'Ngày bắt đầu HĐ thử việc' },
    { title: 'ngaykthdtv', value: 'datehdtv_end', label: 'Ngày kết thúc HĐ thử việc' },
    { title: 'ngaybdhdldl1', value: 'datehdld_start_1', label: 'Ngày bắt đầu HĐLĐ lần 1' },
    { title: 'ngaykthdldl1', value: 'datehdld_end_1', label: 'Ngày kết thúc HĐLĐ lần 1' },
    { title: 'ngaybdhdldl2', value: 'datehdld_start_2', label: 'Ngày bắt đầu HĐLĐ lần 2' },
    { title: 'ngaykthdldl2', value: 'datehdld_end_2', label: 'Ngày kết thúc HĐLĐ lần 2' },
    { title: 'ngaybdhdldl3', value: 'datehdld_start_3', label: 'Ngày bắt đầu HĐLĐ lần 3' },
    { title: 'ngaykthdldl3', value: 'datehdld_end_3', label: 'Ngày kết thúc HĐLĐ lần 3' },
    { title: 'trangthaihd', value: 'hd_status', label: 'Tình trạng HĐ' },
    { title: 'trinhdochuyenmon', value: 'qualification', label: 'Trình độ chuyên môn' },
    { title: 'chuyennganh', value: 'majors', label: 'Chuyên ngành đào tạo' },
    { title: 'truongdaotao', value: 'highschool', label: 'Trường đào tạo' },
    { title: 'companyname', value: 'companyfullname', label: 'Tên công ty' },
    { title: 'departmentname', value: 'partname', label: 'Tên phòng ban' },
    { title: 'chucvu', value: 'chucvu', label: 'Chức vụ' },
    { title: 'mstcongty', value: 'company_mst', label: 'Mã số thuế công ty' },
    { title: 'nguoidaidien', value: 'company_representative', label: 'Người đại diện công ty' },
    { title: 'chucvudaidien', value: 'company_representative_chucvu', label: 'Chức vụ người đại diện' },
    { title: 'diachicongty', value: 'company_address', label: 'Địa chỉ công ty' },
    { title: 'macongty', value: 'company_code', label: 'Mã công ty' },
    { title: 'luong', value: 'luong_ct', label: 'Lương' },
    { title: 'giobatdau', value: 'ca_timestart', label: 'Giờ bắt đầu làm việc' },
    { title: 'gioketthuc', value: 'ca_timeend', label: 'Giờ kết thúc làm việc' },
    { title: 'giolamviec', value: 'ca_giolamviec', label: 'Giờ làm việc cả ngày (08:30 - 18:00)' },
    { title: 'gionghitrua', value: 'ca_reststart', label: 'Giờ bắt đầu nghỉ trưa' },
    { title: 'giohetnghitrua', value: 'ca_restend', label: 'Giờ hết nghỉ trưa' },
    { title: 'giolamviecsang', value: 'ca_giosang', label: 'Giờ làm việc sáng (08:30 - 12:00)' },
    { title: 'giolamviecchieu', value: 'ca_giochieu', label: 'Giờ làm việc chiều (13:30 - 18:00)' },
    { title: 'giolamviecca', value: 'ca_giolamviec_ca', label: 'Giờ làm việc theo ca (Sáng: ... Chiều: ...)' },
    { title: 'giobatdaut7', value: 'ca_timestart_t7', label: 'Giờ bắt đầu làm việc T7' },
    { title: 'gioketthuct7', value: 'ca_timeend_t7', label: 'Giờ kết thúc làm việc T7' },
    { title: 'giolamviect7', value: 'ca_giolamviec_t7', label: 'Giờ làm việc T7 (08:30 - 12:00)' },
];

export const CONTRACT_SYSTEM_VALUES = CONTRACT_SYSTEM_PARAMS.map((item) => item.value);

export const CONTRACT_PARAM_FORMATS = [
    { value: '', label: 'Mặc định', suffix: '' },
    { value: 'upper', label: 'CHỮ HOA', suffix: ':upper' },
    { value: 'lower', label: 'chữ thường', suffix: ':lower' },
    { value: 'title', label: 'Viết Hoa Từng Từ', suffix: ':title' },
];

export const normalizeParamTitle = (title) => {
    return (title || '')
        .trim()
        .replace(/^\$?\{/, '')
        .replace(/\}$/, '')
        .replace(/\s+/g, '_');
};

export const toPlaceholder = (title) => '{' + normalizeParamTitle(title) + '}';

export const toFormattedPlaceholder = (title, format = '') => {
    const normalized = normalizeParamTitle(title);
    const selectedFormat = CONTRACT_PARAM_FORMATS.find((item) => item.value === format);
    return '{' + normalized + (selectedFormat ? selectedFormat.suffix : '') + '}';
};

export const parseContractParams = (params) => {
    if (!params) return [];
    if (Array.isArray(params)) return params;
    try {
        const parsed = JSON.parse(params);
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        return [];
    }
};

export const isCustomTemplateParam = (item) => {
    if (!item) return false;
    return item.custom === true || item.value === 'other' || !CONTRACT_SYSTEM_VALUES.includes(item.value);
};

export const buildTemplateParams = (customParams) => {
    const customItems = (customParams || [])
        .map((item) => ({
            title: toPlaceholder(item.title),
            value: '',
            label: item.label || item.title || '',
            custom: true,
        }))
        .filter((item) => normalizeParamTitle(item.title) !== '');

    return CONTRACT_SYSTEM_PARAMS.map((item) => ({
        ...item,
        title: toPlaceholder(item.title),
    })).concat(customItems);
};
